import React, { useState, useEffect } from "react";
import { CheckIcon } from "@heroicons/react/24/outline";
import { toast } from "react-toastify";
const EditableSelectCell = ({
  value, // current selected ID (string or number)
  options, // [{ id, name }]
  displayValue, // current selected ID (string or number)
  id, // row ID
  field, // field name (e.g., "client_id")
  onSave, // function to call when saving
  className = "",
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(value);

  useEffect(() => {
    setSelectedId(value);
  }, [value]);

  const handleSave = () => {
    onSave({ id, field, value: selectedId });
    setIsEditing(false);
  };
  return (
    <div className={`flex items-center space-x-2 cursor-pointer ${className}`}>
      <div
        onClick={() => {
          if (value !== undefined && value !== null && value !== "————") {
            navigator.clipboard.writeText(value.toString());
          }
        }}
        onDoubleClick={() => setIsEditing(true)}
        className="relative w-full"
      >
        {isEditing ? (
          <select
            className="px-2 py-1 border border-gray-300 rounded-md text-sm text-gray-900"
            value={selectedId}
            onChange={(e) => setSelectedId(e.target.value)}
            onBlur={handleSave}
            autoFocus
          >
            {options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
          </select>
        ) : (
          <div className="group relative text-sm font-medium text-gray-900 text-left w-full">
            <span>{displayValue}</span>
            <div className="absolute -top-1 -right-1 w-0.5 h-0.5 bg-blue-500 rounded-full" />
            <div className="absolute shadow-xl left-1/2 transform -translate-x-1/2 -translate-y-full bg-white text-gray-700 text-sm rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
              {displayValue}
              <span className="text-xs text-gray-500 block mt-1">
                click to edit
              </span>
            </div>
          </div>
        )}
      </div>
      {isEditing && (
        <button
          onClick={handleSave}
          className="p-1 text-gray-400 hover:text-gray-600"
        >
          <CheckIcon className="h-5 w-5" />
        </button>
      )}
    </div>
  );
};

export default EditableSelectCell;
